<p>Share this article</p>
<div class="icons">
    <app-social-media-icon
        *ngFor="let linkToIcon of linkToIcons"
        (click)='onShareLink(linkToIcon.shareLink)'
        [icon]="linkToIcon.icon"
    ></app-social-media-icon>
</div>
